"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SmallDashOutline = {
    name: 'small-dash',
    theme: 'outline',
    nameWithTheme: 'small-dash-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z'
            },
            children: []
        }
    ]
};
exports.default = SmallDashOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/outline/SmallDashOutline.js
// module id = 1006
// module chunks = 0 1